import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, ListChecks, TrendingUp, BookOpen, Users, IdCard, FileSpreadsheet, ShieldCheck, Sparkles } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import PageHero from "../../components/ui-custom/PageHero";
import { QPI_URL } from "../../qpi/site";

const baseTabs = [
  { label: "Home", to: "/employees", icon: LayoutDashboard, end: true },
  { label: "My Sheet", to: "/employees/my-sheet", icon: FileSpreadsheet },
  { label: "Deliverables", to: "/employees/deliverables", icon: ListChecks },
  { label: "Order Bookings", to: "/employees/orders", icon: TrendingUp },
  { label: "Stories", to: "/employees/stories", icon: BookOpen },
  { label: "Directory", to: "/employees/directory", icon: Users },
  { label: "My Profile", to: "/employees/profile", icon: IdCard },
];

const adminTab = { label: "Admin", to: "/employees/admin", icon: ShieldCheck };

const EmployeesLayout = () => {
  const { user } = useAuth();
  const tabs = user?.is_admin ? [...baseTabs, adminTab] : baseTabs;

  return (
    <div>
      <PageHero
        eyebrow="Quality Power Team"
        title={`Welcome${user?.name ? ", " + user.name.split(" ")[0] : ""}`}
        subtitle="Deliverables, order bookings, company news and stories from across Quality Power."
      />
      <section className="px-6 pb-28">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap gap-2 mb-10 border-b border-border/10 pb-4">
            {tabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium tracking-wide transition-colors border ${
                    isActive
                      ? "bg-qcyan/10 border-qcyan/50 text-qcyan"
                      : "border-border/10 text-muted-foreground hover:text-foreground hover:border-border/20"
                  }`
                }
              >
                <tab.icon size={15} />
                {tab.label}
              </NavLink>
            ))}
            <a
              href={QPI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium tracking-wide transition-colors border border-border/10 text-muted-foreground hover:text-foreground hover:border-border/20"
            >
              <Sparkles size={15} />
              QPi
            </a>
          </div>
          <Outlet />
        </div>
      </section>
    </div>
  );
};

export default EmployeesLayout;
